import React, { useEffect } from "react";
import { Table  } from 'antd';
import { connect } from "react-redux";
import { 
    getTrainingClassParticipantList, doTrainingClassParticipantDelete
} from "../../../../../redux/trainingclass/trainingClassState";
import { handleTableChange } from "utils";
import Card from "components/card";
import CrudOption from "components/dropdown/crudoption";
import PopupButton from "components/button/PopupButton";
import TrainingClassParticipantForm from "./TrainingClassParticipantForm";


const TrainingClassParticipantTable = ({ recordList, pagination, doSearch, filters, doDelete, classeId }) => {

    const columns = [
        
        {
            title: 'Participant',
            dataIndex: 'participant_name', 
            key: 'participant_name',
            render: ( participant_name ) => (
                <span>{participant_name}</span>
            ),      
        },

        {
	       title: <PopupButton id="add_class_participants" title="Add Class Participants" label="Add" btnClass="btn-small" modalWidth={600}>
						<TrainingClassParticipantForm recordId={0} mode="edit" classeId={classeId} />
					</PopupButton>,
	        dataIndex: 'tcp_id',
	        key: 'tcp_id',
	        width: '12%',
	        render:(_, record) => <CrudOption 
                                    baseRoute={`/console/training-module-classes/${classeId}/training-class-participants`} 
                                    recordId={record?.tcp_user_id} 
                                    allowView={false}
                                    allowEdit={false}
                                    deleteHandler={() => doDelete({
                                        tcp_user_id: record?.tcp_user_id,
                                        tcp_id: record?.tcp_id,
                                    })} 
                                />
	    },
    ]   
	
    
    useEffect(() => {
        if (classeId) {
            doSearch({paginate: pagination.per_page, classeId});
        } 
    }, [doSearch, classeId]);

    return (   
        <Card extra={"w-full h-full"}>
            <div className="h-full overflow-x-scroll xl:overflow-x-hidden">
                <Table
                    dataSource={recordList} 
                    columns={columns} 
                    rowKey={(record) => record.tcp_id}
                    pagination={{...pagination, 
                        showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} records`,}}    
                    onChange={handleTableChange(doSearch, filters)}                  	
                />
            </div>
        </Card>
    );
};

const mapStateToProps = (state) => ({
  recordList: state.trainingClass.trainingClassParticipantList?.items,
  pagination: state.trainingClass.trainingClassParticipantList?.pagination,
  filters: state.trainingClass.trainingClassParticipantList?.filters,
});

const mapDispatchToProps = (dispatch) => ({
    doSearch: (filters) => dispatch(getTrainingClassParticipantList(filters)),
    doDelete: (id) => dispatch(doTrainingClassParticipantDelete(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TrainingClassParticipantTable);
